/* eslint-disable @typescript-eslint/no-unused-vars */
import { Box, Divider, LinearProgress, Typography } from '@mui/material';
import { LayoutBase } from '../../layouts';
import { VMenu } from '../../components/shared';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { AnomalyService, IAnomalias } from '../../services/api/anomaly/AnomalyService';
import AccordionAnomaly from '../../components/custom/Anomaly/AccordionAnomaly';

export default function AnomalyPage() {
	const url = useParams();
	const navigate = useNavigate();
	const [data, setData] = useState<IAnomalias[]>([]);
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		if (url.id) {
			fetchData(url.id);
		}
	}, [url.id]);

	async function fetchData(uuid: string) {
		setIsLoading(true);
		const response = await AnomalyService.list(uuid);
		setIsLoading(false);
		if (Array.isArray(response)) {
			setData(response);
		} else {
			setData([]);
		}
	}

	return (
		<LayoutBase
			title='Anomalias'
		>
			<Box>
				<VMenu id={url.id} />
				<Divider />
				<Box padding={2}>
					<Box>
						<Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingY: 1, alignItems: 'center' }}>
							<Typography variant='h5'>Acompanhamento de anomalias</Typography>
						</Box>
						<Divider />
					</Box>
					{isLoading ? (
						<Box sx={{ width: '100%', mt: 2 }}>
							<LinearProgress />
						</Box>
					) : (
						data.length === 0 ? (
							<Box sx={{ width: '100%', mt: 4, display: 'flex', justifyContent: 'center' }}>
								<Typography variant="h6" color="text.secondary">
									Sem anomalias cadastradas, por favor adicione no RISROT 
								</Typography>
							</Box>
						) : (
							<AccordionAnomaly
								data={data}
								historico={false}
							/>
						)
					)}
				</Box>
			</Box>
		</LayoutBase>
	);
}